import React from 'react';
import { ArticleHeading1, ArticleHeading2 } from '@cian/ui-kit';
import cn from 'clsx';

import styles from './styles.css';

export interface ITitleFormProps {
  level: 1 | 2;
  children: React.ReactElement | null | string;
}

export const TitleForm: React.FC<ITitleFormProps> = ({ level, children }) => {
  const Tag = level === 1 ? ArticleHeading1 : ArticleHeading2;

  return (
    <div className={cn(styles.root, styles[`level-${level}`])} data-testid="form-title">
      <Tag>{children}</Tag>
    </div>
  );
};

TitleForm.displayName = 'TitleForm';
